<template>
  <article class="accordion">
    <div class="accordion-header">
      <h3 class="is-size-5 has-text-weight-bold">Payment <img src="@/assets/img/yup.png"/></h3>
      <span class="action hover-text-primary" @click="editStep()">EDIT</span>
    </div>
    <div class="accordion-body">
      <div class="accordion-content">
        <div class="checkout-accordion-content-wrap">
            <h3 class="accordion-title is-size-5 has-text-weight-bold">Payment</h3>
            <div class="checkout-accordion-content">
              
              <!-- if checkout disabled throw messsage -->
              <div v-if="checkoutDisabled">
                <p>We aren't able process payments right now. Please try again later.</p>
              </div>

              <div v-else>
                
                <!-- Payment options -->
                <p
                  class="mt-5 is-size-16 has-text-weight-bold"
                >How would you like to pay?</p>
                <div class="is-flex is-full">
                  <div class="field is-half-width mt-5" v-if="enablePayNow">
                    <input
                      class="is-checkradio"
                      v-model="pay_later"
                      id="paynowCheck"
                      type="radio"
                      :value="0"
                    />
                    <label for="paynowCheck" class="">Pay now</label>
                  </div>
                  
                  <div class="field is-half-width mt-5" v-if="enablePaylater">
                    <input
                      class="is-checkradio"
                      v-model="pay_later"
                      id="payatstore"
                      type="radio"
                      :value="1"
                    />
                    <label for="payatstore" class="">{{ vg_checkoutOrderType.order_receive_method == 'pickup' ? 'Pay at store' : 'Pay at door'}}</label>
                  </div>
                </div>

                <!-- Payment options is paying now -->


                <!-- colver -->
                <template v-if="vg_selectedStore.settings.payment_processor_details && (vg_selectedStore.settings.payment_processor_details.provider_name == 'clover_payment')">
                  <form action="_self" class="clover-form" method="post" id="payment-form" v-show="(pay_later == 0) && enablePayNow">
                    <div class="mb-5">
                      <div id="card-number" class="clover-form-field"></div>
                      <div class="clover-error-msg has-text-red" id="card-number-errors"></div>
                    </div>
                    <div class="mb-5">
                      <div id="card-date" class="clover-form-field"></div>
                      <div class="clover-error-msg has-text-red" id="card-date-errors"></div>
                    </div>
                    <div class="mb-5">
                      <div id="card-cvv" class="clover-form-field"></div>
                      <div class="clover-error-msg has-text-red" id="card-cvv-errors"></div>
                    </div>
                    <div class="mb-5">
                      <div id="card-postal-code" class="clover-form-field"></div>
                      <div class="clover-error-msg has-text-red" id="card-postal-code-errors"></div>
                    </div>
                    <div id="card-errors"></div>
                    <div id="card-response"></div>
                  </form>
                </template>
                <!-- colver ends -->


        
                 <!-- monaris card info -->
                <template v-if="vg_selectedStore.settings.payment_processor_details && (vg_selectedStore.settings.payment_processor_details.provider_name == 'fiska_payment') && (vg_selectedStore.settings.payment_processor_details.terminal_id) && (vg_selectedStore.settings.payment_processor_details.secret) && enablePayNow">
                  <!-- template check value par later value hide n show -->
                   <div v-if="pay_later == 0">
                       <iframe v-if="fiskaIframeUrl() && (step == 'payment')" id="fiskaIframe" :src="fiskaIframeUrl()" frameborder="0" ></iframe>
                   </div>
                </template>

                  <!-- monaris card info -->
                <template v-if="vg_selectedStore.settings.payment_processor_details && (vg_selectedStore.settings.payment_processor_details.provider_name == 'moneris_payment') && (vg_selectedStore.settings.payment_processor_details.payment_info) && enablePayNow">
                  <!-- template check value par later value hide n show -->
                   <div v-show="pay_later == 0">
                      <h3 class="billing-heading heading-with-lock"><strong>Credit card</strong> <i class="fas fa-lock"></i></h3>
                      <iframe
                        id="monerisFrame"
                        :src="monerisIframeUrl"
                        frameborder="0"
                        width="100%"
                      ></iframe>
                   </div>
                </template>
         

                <!-- elavon info -->
                <div class="elavon-payment-detail-wrap" v-if="(pay_later == 0) && vg_selectedStore.settings.payment_processor_details && (vg_selectedStore.settings.payment_processor_details.provider_name == 'elavon_payment') && enablePayNow">
                  <h3 class="billing-heading heading-with-lock"><strong>Credit card</strong>  <i class="fas fa-lock"></i></h3>
                  <div class="field">
                    <div class="control">
                      <validation-provider name="card number" ref="elavon_card_number" rules="required">
                        <template #default="{ errors }">
                          <input
                            v-model="elavon.card_number"
                            class="input checkout-user-field hide-arrow"
                            name="Card Number"
                            onKeyPress="if(this.value.length==16) return false;"
                            type="number"
                            placeholder="Card Number"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">

                      <validation-provider name="card expiry date" ref="elavon_exp_date" rules="required">
                        <template #default="{ errors }">
                          <input
                            v-model="elavon.exp_date"
                            class="input checkout-user-field"
                            name="Card Expiry date"
                            onKeyPress="if(this.value.length==4) return false;"
                            type="text"
                            placeholder="MMYY"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="field">
                    <div class="control">
                      <validation-provider name="CVV2" ref="elavon_cvv2cvc2" rules="required">
                        <template #default="{ errors }">
                          <input
                            v-model="elavon.cvv2cvc2"
                            onKeyPress="if(this.value.length==4) return false;"
                            class="input checkout-user-field"
                            name="CVV2"
                            type="number"
                            placeholder="CVV2"
                          />
                          <span class="validation-error">{{ errors[0] }}</span>
                        </template>
                      </validation-provider>
                    </div>
                  </div>
                  
                  <h3 class="billing-heading has-text-weight-semibold">Billing Details</h3>
                  <div class="form-field-inline">
                    <div class="field">
                      <div class="control">
                        <validation-provider name="billing address" ref="elavon_billing_address" rules="required">
                          <template #default="{ errors }">
                            <input
                              v-model="elavon.address"
                              class="input checkout-user-field"
                              name="billing address"
                              type="text"
                              placeholder="Billing address"
                            />
                            <span class="validation-error">{{ errors[0] }}</span>
                          </template>
                        </validation-provider>
                      </div>
                    </div>
                    <div class="field">
                      <div class="control">
                        <validation-provider name="billing zip" ref="elavon_billing_zip" rules="required">
                          <template #default="{ errors }">
                            <input
                              v-model="elavon.zip"
                              class="input checkout-user-field"
                              name="billing zip"
                              type="text"
                              placeholder="Billing zip"
                            />
                            <span class="validation-error">{{ errors[0] }}</span>
                          </template>
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  
                </div>

                <!-- paysafe card info -->
                <div
                  class="paysafe-wrapper"
                  v-if="vg_selectedStore.settings.payment_processor_details && vg_selectedStore.settings.payment_processor_details.token_key && (vg_selectedStore.settings.payment_processor_details.provider_name == 'merrco_payment')"
                >
                  <div v-show="pay_later == 0 && enablePayNow">
                    <!-- hide and show, so no need to refetch data -->
                    <h3 class="billing-heading heading-with-lock"><strong>Credit card</strong>  <i class="fas fa-lock"></i></h3>
                    <div>
                      <div id="cardNumber" class="paysafe-inputs"></div>
                      <div id="expiryDate" class="paysafe-inputs"></div>
                      <div id="cvv" class="paysafe-inputs"></div>
                    </div>
           
                    <!-- if payment type is paysafe we need to capture billing details -->
                    <h3 class="billing-heading has-text-weight-semibold">Billing Details</h3>
                    <div class="field">
                      <div class="control">
                        <validation-provider name="street" ref="paysafe_billing_address" rules="required">
                          <template #default="{ errors }">
                            <!-- <gmap-autocomplete
                              autocomplete="nope"
                              id="billing_address"
                              class="input has-bg-grey google-autocomplete has-text-black"
                              style="height: 2.625rem; padding: 10px 20px 10px 20px; color: #666666; font-size: 0.9375rem; background-color: #fff; box-shadow: none; border-radius: 4px; border: none; width: 100%;border: 1px solid #808080;"
                              large
                              name="billing_street"
                              placeholder="Street"
                              @place_changed="setPaysafeBillingStreet"
                              @keyup="resetPaysafeBillingStreet"
                              :select-first-on-enter="true"
                              :componentRestrictions="{ country: ['ca', 'us'] }"
                            ></gmap-autocomplete>
                            <p class="is-size-12 is-italic has-text-weight-light mt5">Please type in your address and select one from suggestions.</p> -->
                            <!-- <span
                              class="validation-error"
                              v-if="paysafe_billing_error"
                            >{{ paysafe_billing_error }}</span> -->
                            <input type="text" v-model="paysafe_billing.street" name="paysafe_billing_address" class="input" placeholder="Billing Street"/>
                            <span class="validation-error">{{ errors[0] }}</span>
                          </template>
                          
                        </validation-provider>
                      </div>
                    </div>
        
                    <div class="form-field-inline">
                      <div class="field">
                        <div class="control">
                          <validation-provider name="city" ref="paysafe_billing_city" rules="required">
                            <template #default="{ errors }">
                              <input
                                v-model="paysafe_billing.city"
                                class="input"
                                name="City"
                                type="text"
                                placeholder="City"
                              />
                              <span class="validation-error">{{ errors[0] }}</span>
                            </template>
                          </validation-provider>
                        </div>
                      </div>
                      <div class="field">
                        <div class="control">
                          <validation-provider name="state" ref="paysafe_billing_state" rules="required|length:2|validate_state_code">
                            <template #default="{ errors }">
                              <input
                                v-model="paysafe_billing.state"
                                class="input"
                                name="State"
                                type="text"
                                placeholder="State"
                              />
                              <span class="validation-error">{{ errors[0] }}</span>
                            </template>
                          </validation-provider>
                        </div>
                      </div>
                    </div>

                    <div class="form-field-inline">
                      <div class="field">
                        <div class="control">
                          <validation-provider name="country" ref="paysafe_billing_country" rules="required|validate_country_code">
                            <template #default="{ errors }">
                              <input
                                v-model="paysafe_billing.country"
                                class="input"
                                name="Country"
                                type="text"
                                placeholder="Country"
                              />
                              <span class="validation-error">{{ errors[0] }}</span>
                            </template>
                          </validation-provider>
                        </div>
                      </div>
                      <div class="field">
                        <div class="control">
                          <validation-provider name="zip" ref="paysafe_billing_zip" rules="required">
                            <template #default="{ errors }">
                              <input
                                v-model="paysafe_billing.zip"
                                class="input"
                                name="Zip"
                                type="text"
                                placeholder="Zip"
                              />
                              <span class="validation-error">{{ errors[0] }}</span>
                            </template>
                          </validation-provider>
                        </div>
                      </div>
                    </div>
                   
                    <!-- paysafe billing details ends -->
                  </div>
                </div>

               <template v-if="pay_later">
                  <div class="accordion-action mt20 has-text-right">
                    <a
                    @click.prevent="nextStep()"
                    href="#"
                    class="button is-fullwidth-mobile bg-secondary hover-opacity-7 text-white btn-complete"
                    >
                      CONTINUE
                    </a>
                </div>
               </template>
               <template v-else>
                 <div class="accordion-action mt20 has-text-right" v-if="vg_selectedStore.settings.payment_processor_details && (vg_selectedStore.settings.payment_processor_details.provider_name != 'fiska_payment')">
                  <a
                  @click.prevent="nextStep()"
                  href="#"
                  class="button is-fullwidth-mobile bg-secondary hover-opacity-7 text-white btn-complete"
                  >
                    CONTINUE
                  </a>
                </div>
               </template>
                
              </div>

            </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import CartApis from '@/Components/Controllers/CartApis';
import Env from '@/env';
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import moment from 'moment';
import sha512 from 'js-sha512';
import NormalApis from '@/Components/Controllers/NormalApis';
import LocationApis from '@/Components/Controllers/LocationApis';

export default {
  components: {
 
  },
  name: 'CheckoutPayment',
  props: ['step'],
  data() {
    return {
      cloverDetails: {},
      cloverAccessKey: '',
      monerisEventLoaded: false, 
      pay_later: 1,
      elavon:{
        token: '',
        card_number: '',
        exp_date: '',
        cvv2cvc2: '',
        address: '',
        zip: '',
      },

      paysafeInstance: {},
      paysafe_billing_error: '',
      paysafe_billing: {
        street: '',
        city: '',
        state: '',
        country: '',
        zip: ''
      }

    };
  },

   watch: {
    
    'vg_fiskaDetails'(fiskaData) {
      if(!_.isEmpty(fiskaData) && fiskaData.CARDREFERENCE){
        this.confirmOrder({ token: fiskaData.CARDREFERENCE })
      }
    },

    'pay_later'(val) {
      // if pay now and payment fiska reset iframe
      if(!val && this.vg_selectedStore.settings.payment_processor_details.provider_name == 'fiska_payment') {
        // Mean pay now
        this.va_setFiskaDetails({
          fiska_response: {}
        })
      }
    },

    'paysafe_billing.state'(val) {
      val = val.replace(/\./g,"").toUpperCase().trim();
      if(val.length > 2){
        val = val.slice(0,2)
      } 
      this.paysafe_billing.state = val;
    },

    'vg_checkoutOrderType.order_receive_method'() {
      if (this.enablePayNow) {
        this.pay_later = 0;
      } if(this.enablePaylater) {
        this.pay_later = 1
      }
    },
  },
  
  computed: {
    
    /**
     * Checkout disabled mean store doesnot have pay now or later option so hide all buttons
     */
    checkoutDisabled() {
      if (this.enablePayNow == false && this.enablePaylater == false) {
        return true;
      }
      return false;
    },

    kioskMode() {
       return (this.$route.query['kiosk'] && ( (this.$route.query['kiosk'] == 1) || (this.$route.query['kiosk'] == 'true') ) ) ? true : false;
    },

    /**
     * Paylater enable / disable
     */
    enablePaylater() {
      
      if (this.kioskMode) {
        //return false; // hard coded false
        // overide if guest only
        if(this.vg_selectedStore.settings.kiosk_settings) {
          return this.vg_selectedStore.settings.kiosk_settings.pay_later;
        } else {
          return false;
        }
      }

      // Non guest
      if (this.vg_checkoutOrderType.order_receive_method == 'pickup') {
        return this.vg_selectedStore.settings.pickup_orders ? this.vg_selectedStore.settings.pickup_orders.pay_later : true;
      } else if (this.vg_checkoutOrderType.order_receive_method == 'delivery') {
        return this.vg_selectedStore.settings.delivery_orders ? this.vg_selectedStore.settings.delivery_orders.pay_later : true;
      }

      // depending on selected field pay later
      return true;
    },

    /**
     * Guest user / guest_only active
     */
    guestOnly() {
      if (this.vg_guestLandedQueries['guest-only'] || (this.vg_guestLandedQueries['guest-only'] == 'true') || this.$route.query['guest-only'] || this.$route.query['kiosk']) {
        if(this.vg_selectedStore.settings.kiosk_settings){
          return this.vg_selectedStore.settings.kiosk_settings ? this.vg_selectedStore.settings.kiosk_settings.is_enabled : false
        }
      }
      return false;
    },

    /**
     * Paynow enable / disable
     */
    enablePayNow() { 

    // lets check if payment key is not avaiable 
      if(!this.vg_selectedStore.settings.payment_processor_details){
        return false;
      }

       // Disable pay now if location has blank moneris data 
      if( this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.payment_info == '') && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'moneris_payment') ) {
        return false;
      } 
      
      // For merrco if payment details missing
      if(this.vg_selectedStore.settings.payment_processor_details && this.vg_selectedStore.settings.payment_processor_details.provider_name == 'merrco_payment' && this.vg_selectedStore.settings.payment_processor_details.token_key == '') {
        return false;
      }

       // For clover to display payment must have access key
      if(this.vg_selectedStore.settings.payment_processor_details && this.vg_selectedStore.settings.payment_processor_details.provider_name == 'clover_payment' && !this.cloverAccessKey  ) {
        return false;
      }

       // For guest
      if (this.guestOnly && this.vg_selectedStore.settings.kiosk_settings) {
        return this.vg_selectedStore.settings.kiosk_settings.pay_now;
      }
      
      // Others
      if (this.vg_checkoutOrderType.order_receive_method == 'pickup') {
        // Check key else set to true
        return this.vg_selectedStore.settings.pickup_orders ? this.vg_selectedStore.settings.pickup_orders.pay_now : true;
      } else if (this.vg_checkoutOrderType.order_receive_method == 'delivery') {
        // Check key else set to true
        return this.vg_selectedStore.settings.delivery_orders ? this.vg_selectedStore.settings.delivery_orders.pay_now : true;
      }
      return true;
    },

    monerisIframeUrl() {
      return `${Env.moneris.url}?id=${this.vg_selectedStore.settings.payment_processor_details.payment_info ?  this.vg_selectedStore.settings.payment_processor_details.payment_info : ''}&pmmsg=true&enable_exp=1&enable_cvd=1&css_body=background:transparent;&css_textbox=width:100%;background:white;padding:10px;border-radius:5px;border:1px%20solid%20grey;height:40px;border-color:grey;font-size:16px;margin-top:8px;&display_labels=2&exp_label=Expiry Date (MMYY)`;
    },

    ...mapGetters({
      vg_cartId: "cart/id",
      vg_businessprofile: "businessprofile/detail",
      vg_cartItems: "cart/cartItems",
      vg_selectedStore: "location/selected",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_cartTax: "cart/cartTax",
      vg_cartPromoCode: "cart/promocode",
      vg_cartGrandTotal: "cart/cartGrandTotal",
      vg_weightOnCart: "cart/cartWeight",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_checkoutOrderType: "checkout/ordertype",
      vg_checkoutOrderType: "checkout/ordertype",
      vg_fiskaDetails: "fiska/details",
    }),

  },


  async mounted() {
   
    // reset fiska on every mount
    this.va_setFiskaDetails({
      fiska_response: {}
    })
    /**
     * Handle payment
     */
    if (this.enablePayNow) {
      this.pay_later = 0;
    } if(this.enablePaylater) {
      this.pay_later = 1
    }

    /**
     *  Load js depending upon payment processes
     *  */

    // Load paysafe if payment is paysafe
    if (this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'merrco_payment') ) {
      if(this.vg_selectedStore.settings.payment_processor_details.token_key){
        Helpers.loadPaysafeJs(Env.paysafe.url, this.vg_selectedStore.settings.payment_processor_details.token_key)
        // on next tick add attribute on autocomplete, not workiong so lets set time out for 1 sec to add
        // setTimeout(function(){
        //   // once the div loaded change it 
        //   document.getElementById("billing_address").setAttribute("autocomplete", "nope");
        // }, 1000)
      } else {
        console.log('Paysafe payment token key missing.')
      }
    }

     // Load elavon iframes
    if (this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'elavon_payment') ) {
      Helpers.loadElavonJs(Env.elavon.jsurl)
    }

    // Load clover
    if (this.vg_selectedStore.settings.payment_processor_details && this.vg_selectedStore.settings.payment_processor_details.access_token && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'clover_payment') ) {
      // we might need to get access token from api
      let cloverRes = await LocationApis.getLocationCloverApiToken(this.vg_selectedStore.id);
      if(cloverRes.status == 200 && cloverRes.data.payload && cloverRes.data.payload.apiAccessKey){
        this.cloverAccessKey = cloverRes.data.payload.apiAccessKey;
        this.initClover(cloverRes.data.payload.apiAccessKey);
      } else {
        this.cloverAccessKey = '';
      }
    }


     // Setup for monaris
    if (this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'moneris_payment') && this.vg_selectedStore.settings.payment_processor_details.payment_info && this.monerisEventLoaded == false) {
      if (window.addEventListener) {
        window.addEventListener("message", this.monerisResponse, false);
      } else {
        if (window.attachEvent) {
          window.attachEvent("onmessage", this.monerisResponse);
        }
      }
      // once event loaded make it true / loaded, load only once
      this.monerisEventLoaded = true;
    }

  },

  // beforeDestroy() {
  //   bus.$off('checkout-step');
  // },

  methods: {

    fiskaIframeUrl() {
      if(this.vg_selectedStore.settings.payment_processor_details && this.vg_selectedStore.settings.payment_processor_details.terminal_id && this.vg_selectedStore.settings.payment_processor_details.secret){
        let merchantRef = Date.now(); //Env.fiska.merchantRef; // Env.fiska.merchantId; //
        let currentDateTime = moment(Date.now()).format('DD-MM-YYYY:HH:MM:SS:SSS');
        let action = 'register';
        let terminalId = this.vg_selectedStore.settings.payment_processor_details.terminal_id;
        let secret = this.vg_selectedStore.settings.payment_processor_details.secret;
        let hashForm = [terminalId, merchantRef, currentDateTime, action, secret].join(':');
        let hash = sha512(hashForm);
        let receipentUrl = window.location.origin + '/fiska-response?noage=1'; // 
        return  `https://testpayments.nuvei.com/merchant/securecardpage?ACTION=register&TERMINALID=${terminalId}&MERCHANTREF=${merchantRef}&DATETIME=${currentDateTime}&RECEIPTPAGEURL=${receipentUrl}&HASH=${hash}&STOREDCREDENTIALUSE=UNSCHEDULED&INIFRAME=Y`
      }
      return '';
      
    },
 
    async nextStep() {
     
      const self = this;
      // that mean pay now 
      if(this.pay_later == false) {
        // lets work on elavon
        if( this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'elavon_payment') ){
          // Validate card fields before submit for elavon and
          let validateElavonCard = await Helpers.validateRefs(this, ['elavon_card_number', 'elavon_exp_date', 'elavon_cvv2cvc2', 'elavon_billing_address', 'elavon_billing_zip']);
          if (!validateElavonCard) {
            return false;
          }
         this.generateElavonTokenAndConfirm();
        
        } else if( this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'merrco_payment')) {

          // Now if payment if merrco thay must have data lets check
            if(!this.vg_selectedStore.settings.payment_processor_details.token_key) {
              return self.va_snackbar({
                type: "warning",
                message: 'Payment card not setup.'
              });
            }
          // Handle merrco payment )
          // this.paysafe_billing.street = document.getElementById('billing_address').value; // set typed value
          // if (this.paysafe_billing.street == '') {
          //   // custom validate coz this is autocomplete package
          //   return this.paysafe_billing_error = "Invalid Address.";
          // }
          let paysafe_validation = await Helpers.validateRefs(this, [ 'paysafe_billing_address', 'paysafe_billing_city', 'paysafe_billing_state', 'paysafe_billing_country', 'paysafe_billing_zip']);
          if (!paysafe_validation) {
            return false;
          }
          self.va_spinner(true);
          window.paysafeInstance.tokenize({
            vault: {
              holderName: this.vg_checkoutOrderType.user.first_name + ' ' + this.vg_checkoutOrderType.user.last_name,
            }
          }, function(instance, error, result) {
            if (error) {
              self.va_snackbar({
                type: "warning",
                message: error.displayMessage
              });
              self.va_spinner(false);
            } else {
              // merrco_payment start
              self.va_spinner(false);
              self.confirmOrder({ token: result.token  })
            }
          })

        } else if( this.vg_selectedStore.settings.payment_processor_details && this.vg_selectedStore.settings.payment_processor_details.payment_info && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'moneris_payment') ) {
          
          self.va_spinner(true);
          await this.getMonerisData();
          self.va_spinner(false);
          

        } else if( this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'clover_payment') ) {
    
          await this.getCloverToken();
        
        }
        // work space

        return false;

      } else {
        // Pass to move forward
        this.confirmOrder({ token: '' })
      }


      // Validate and push on checkout obj
      // bus.$emit('checkout-step', {
      //   step: 'review',
      // })

    },

    editStep() {
      this.va_setFiskaDetails({
        fiska_response: {}
      })
      bus.$emit('checkout-step', {
        step: 'payment',
      })
    },

     /**
     * Get moneris data
     */
    getMonerisData() {
      var monFrameRef = document.getElementById('monerisFrame').contentWindow;
      monFrameRef.postMessage('tokenize', `${Env.moneris.url}?id=${this.vg_selectedStore.settings.payment_processor_details.token_key}`);
    },

    
     /**
     *  Generate elavon session token
     */
    async generateElavonSessionToken() {
      let elavonSessionToken = await CartApis.generateElavonSessionToken(this.vg_selectedStore.id);
      if(elavonSessionToken.status == 200){
        this.elavon.token = elavonSessionToken.data.payload.session_token;
      } else {
        this.elavon.token = '';
      }
      return elavonSessionToken;
    },
    /**
     * Generate elavon token and Confirm
     */
    async generateElavonTokenAndConfirm() { 
      this.va_spinner(true);
      const self = this;
      // This will attach session token on elavon
      let sessiontoken = await this.generateElavonSessionToken();
      // If somthing went wrong while creating session token 
      if(sessiontoken.status != 200){
        this.va_spinner(false);
        return self.va_snackbar({
          type: "warning",
          message: sessiontoken.response.data.msg
        });
      }
      ConvergeEmbeddedPayment.pay({
        ssl_txn_auth_token: this.elavon.token,
        ssl_card_number: this.elavon.card_number,
        ssl_exp_date: this.elavon.exp_date,
        ssl_verify: 'Y',
        ssl_avs_address: this.elavon.address,
        ssl_avs_zip: this.elavon.zip,
        ssl_get_token: 'Y',
        ssl_add_token: 'Y',
        ssl_first_name: this.vg_checkoutOrderType.user.first_name,
        ssl_last_name: this.vg_checkoutOrderType.user.last_name,
        ssl_cvv2cvc2: this.elavon.cvv2cvc2,
        ssl_amount: 0.00,
        ssl_merchant_txn_id: this.vg_cartId,// need to send cart id this.vg_selectedStore.settings.payment_processor_details.ssl_merchant_id ? this.vg_selectedStore.settings.payment_processor_details.ssl_merchant_id : Env.elavon.ssl_merchant_id
      }, {
        onError: function (error) {
          self.va_snackbar({
            type: "warning",
            message: error.errorMessage
          });
          self.va_spinner(false);
        },
        onDeclined: function (response) {
          console.log('decline')
          self.va_snackbar({
            type: "warning",
            message: response.errorMessage ? response.errorMessage : 'Card ' + response.ssl_token_response,
          });
          self.va_spinner(false);
        },
        onApproval: function (response) {
          self.va_spinner(false);
          self.confirmOrder({ token: response.ssl_token });
        }
      });
    
    },

    /**
     * Confirm order
     */
    async confirmOrder({ token }) {
      let obj = {
        pay_later: this.pay_later,
        token: token,
      };
      // if coming from merrrco insert billing details
      if ( this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'merrco_payment') ) {
        obj.billingDetails = this.paysafe_billing;
      }

      if ( (this.pay_later == false) && this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'fiska_payment') ) {
        obj.payment_info = {
          postal_code : 'TEST123',
          card_type : this.vg_fiskaDetails.CARDTYPE,
          card_number : this.vg_fiskaDetails.MASKEDCARDNUMBER,
        };
      } else if ((this.pay_later == false) && this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name == 'clover_payment')){
        obj.payment_info = {
          card_type : this.cloverDetails.card?this.cloverDetails.card.brand : '',
          card_number : this.cloverDetails.card?this.cloverDetails.card.last4 : '',
        };
      } else {
        // if key exists after switch tabs
        obj.payment_info = null;
      }

      this.va_setPayment(obj);
      bus.$emit('checkout-step', {
        step: 'review',
      })

    },


    /**
     * Set billing street
     */
    async setPaysafeBillingStreet(billingAddress) {
      // if (_.isEmpty(billingAddress)) {
      //   return;
      // }
      // if(billingAddress.name){
      //   // instead of long text display onnly the street name
      //   document.getElementById('billing_address').value = billingAddress.name;
      // }
      // this.paysafe_billing_error = '';
      // // Now we have billing address values lets open other fields

      // let postcode = Helpers.getDetailFromGmapAutoComplete(billingAddress.address_components, 'postal_code');
      // if (postcode == '') {
      //   // reset billing values
      //   this.paysafe_billing = Helpers.setObjValueEmpty(this.paysafe_billing);
      //   return this.va_snackbar({
      //     type: "warning",
      //     message: "Cannot find your post code. Please type in full Address."
      //   });
      // }

      // this.paysafe_billing = {
      //   street: document.getElementById('billing_address').value, //billingAddress.name,
      //   city: Helpers.getDetailFromGmapAutoComplete(billingAddress.address_components, 'locality'),
      //   state: Helpers.getDetailFromGmapAutoComplete(billingAddress.address_components, 'administrative_area_level_1', 'short_name') ? Helpers.getDetailFromGmapAutoComplete(billingAddress.address_components, 'administrative_area_level_1', 'short_name') : Helpers.getDetailFromGmapAutoComplete(billingAddress.address_components, 'administrative_area_level_2', 'short_name'),
      //   country: Helpers.getDetailFromGmapAutoComplete(billingAddress.address_components, 'country', 'short_name'),
      //   zip: postcode,
      // };
    },

    resetPaysafeBillingStreet($e) {
      // Check the value from element id 
      // let billingAddress = $e.target.value
      // if (billingAddress == undefined || billingAddress == '') {
      //   // now reset 
      //   // this.paysafe_billing = {
      //   //   street: '',
      //   //   city: '',
      //   //   state: '',
      //   //   country: '',
      //   //   zip: ''
      //   // };
      //   return this.paysafe_billing_error = "Invalid Address. Please select one from suggestions.";
      // } else {
      //   this.paysafe_billing.street = billingAddress;
      //   this.paysafe_billing_error = "";
      // }
    },

    monerisResponse: function (e) {
   
      if(this.step != 'payment') return;
      if (this.vg_selectedStore.settings && this.vg_selectedStore.settings.payment_processor_details && (this.vg_selectedStore.settings.payment_processor_details.provider_name != 'moneris_payment') ) {
        return;
      }
      
      if (e.data && e.data != undefined) {
        if (typeof e.data == 'object') {
          // only string is allowed
          return;
        }
      }
    
      var respData = eval("(" + e.data + ")");
      if (respData.dataKey) {
        this.confirmOrder({ token: respData.dataKey });
      } else {
        // console.log(respData)
        this.va_snackbar({
          type: "warning",
          message: respData.errorMessage ? 'Sorry, the payment processor ran in to issue.' : '', //'Sorry, the payment processor ran in to issue.',//respData.errorMessage,
        });
      }
    },

    /**
     * Init clover
     */
     async initClover(access_token) {
      //console.log('ct-' + access_token)
      await Helpers.loadCloverJs(Env.clover.sdkUrl);
      window.clover = new Clover(access_token); // hard c oded for now till we have api
      const elements = clover.elements();
      const styles = {
        body: {
          fontFamily: 'Roboto, Open Sans, sans-serif',
          fontSize: '15px',
        },
        input: {
          fontSize: '15px',
          padding: '8px',
          margin: '0px',
          backgroundColor: 'white',
          border: '1px solid #ccc',
          height: '40px',
          borderRadius: '4px',
          background: 'none'
        },
        "input:focus": { border: "1px solid #ccc" }
      };
      const cardNumber = elements.create('CARD_NUMBER', styles);
      const cardDate = elements.create('CARD_DATE', styles);
      const cardCvv = elements.create('CARD_CVV', styles);
      const cardPostalCode = elements.create('CARD_POSTAL_CODE', styles);
      cardNumber.mount('#card-number');
      cardDate.mount('#card-date');
      cardCvv.mount('#card-cvv');
      cardPostalCode.mount('#card-postal-code');  

      // const cardResponse = document.getElementById('card-response');
      const displayCardNumberError = document.getElementById('card-number-errors');
      const displayCardDateError = document.getElementById('card-date-errors');
      const displayCardCvvError = document.getElementById('card-cvv-errors');
      const displayCardPostalCodeError = document.getElementById('card-postal-code-errors');
      
      // Handle real-time validation errors from the card Element.
      cardNumber.addEventListener('change', function(event) {
        displayCardNumberError.innerHTML = event.CARD_NUMBER.error || '';
      });

      cardNumber.addEventListener('blur', function(event) {
        displayCardNumberError.innerHTML = event.CARD_NUMBER.error || '';
      });

      cardDate.addEventListener('change', function(event) {
        displayCardDateError.innerHTML = event.CARD_DATE.error || '';
      });

      cardDate.addEventListener('blur', function(event) {
        displayCardDateError.innerHTML = event.CARD_DATE.error || '';
      });

      cardCvv.addEventListener('change', function(event) {
        displayCardCvvError.innerHTML = event.CARD_CVV.error || '';
      });

      cardCvv.addEventListener('blur', function(event) {
        displayCardCvvError.innerHTML = event.CARD_CVV.error || '';
      });

      cardPostalCode.addEventListener('change', function(event) {
        displayCardPostalCodeError.innerHTML = event.CARD_POSTAL_CODE.error || '';
      });

      cardPostalCode.addEventListener('blur', function(event) {
        displayCardPostalCodeError.innerHTML = event.CARD_POSTAL_CODE.error || '';
      });

     },


    /**
     * Get clover token
     */
    async getCloverToken() {
    
      const self = this;
    
      let cardFields = {
        CARD_NUMBER: document.getElementById('card-number-errors'),
        CARD_DATE: document.getElementById('card-date-errors'),
        CARD_CVV: document.getElementById('card-cvv-errors'),
        CARD_POSTAL_CODE: document.getElementById('card-postal-code-errors'),
      };

      self.va_spinner(true);
      clover.createToken()
     .then(function(result) {
       self.va_spinner(false);
        if (result.errors) {
          Object.entries(result.errors).forEach((entry,  i) => {
            let [key, value] = entry;
            //console.log(key, value, i);
            cardFields[key].innerHTML = value
            // lets display first error
            if(i == 0) {
              self.va_snackbar({
                type: "warning",
                message: value
              })
            }
          });
        } else {
          self.cloverDetails = result;
          if(result.token) {
            self.confirmOrder({ token: result.token })
          } else {
            self.va_snackbar({
              type: "warning",
              message: 'Sorry, the payment processor ran in to issue.', //'Sorry, the payment processor ran in to issue.',//respData.errorMessage,
            });
          }
          
        }
     }).catch(function(data){
       self.va_spinner(false);
       console.log(data);
     });
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
      va_setPayment: "checkout/setPayment",
      va_setFiskaDetails: "fiska/setDetails",
    })

  },
};
</script>

